import { Grid, Typography } from "@mui/material";

import defaultStyles from "./styles";

interface StyledOrDividerProps {
  text: string;
}

const StyledOrDivider = ({ text }: StyledOrDividerProps) => {
  return (
    <Grid container sx={defaultStyles.container}>
      <Grid item sx={{ flexGrow: 1 }}>
        <hr style={defaultStyles.border} />
      </Grid>
      <Grid item>
        <Typography variant="body2" sx={defaultStyles.orText}>
          {text}
        </Typography>
      </Grid>
      <Grid item sx={{ flexGrow: 1 }}>
        <hr style={defaultStyles.border} />
      </Grid>
    </Grid>
  );
};

export default StyledOrDivider;
